/**
 * Apply itinerary wall clock (HH:mm, 24h) onto a calendar day in local time.
 * Kept in sync with `functions/src/services/flightStatusDepartureResolution.ts`.
 */
export function mergeItineraryTimeOntoDay(day: Date, startTime?: string | null): Date {
  if (typeof startTime !== 'string') return day;
  const raw = startTime.trim();
  if (!raw || raw.toLowerCase() === 'flexible') return day;
  const parts = raw.split(':');
  const h = Number.parseInt(parts[0] ?? '', 10);
  const m = Number.parseInt(parts[1] ?? '0', 10);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return day;
  const next = new Date(day.getTime());
  next.setHours(h, m, 0, 0);
  return next;
}
